/**
 * kayer.pl landing FX: PL stays PLN, CZ → CZK, other markets → EUR.
 * Rates from NBP table A (mid, PLN per 1 unit). Checkout may differ.
 */
(function (w) {
  var NBP = 'https://api.nbp.pl/api/exchangerates/rates/a/';
  var cache = {};

  function countryIso(root) {
    var fromRoot = root && root.getAttribute('data-kayer-country');
    var fromShopify = w.Shopify && Shopify.country;
    var fromWin = w.KayerShopCountry;
    return String(fromRoot || fromShopify || fromWin || 'PL').toUpperCase();
  }

  function targetCurrency(cc) {
    if (cc === 'PL') return 'PLN';
    if (cc === 'CZ') return 'CZK';
    return 'EUR';
  }

  function langOf(root) {
    var raw = String((root && root.getAttribute('data-lang')) || 'pl').toLowerCase();
    if (raw.indexOf('en') === 0) return 'en';
    if (raw.indexOf('uk') === 0) return 'uk';
    if (raw.indexOf('cs') === 0) return 'cs';
    return 'pl';
  }

  function intlLocale(lang) {
    if (lang === 'en') return 'en-GB';
    if (lang === 'uk') return 'uk-UA';
    if (lang === 'cs') return 'cs-CZ';
    return 'pl-PL';
  }

  function formatMoney(n, cur, lang) {
    var rounded = Math.round(n);
    try {
      return new Intl.NumberFormat(intlLocale(lang), { maximumFractionDigits: 0 }).format(rounded) + ' ' + cur;
    } catch (e) {
      return String(rounded).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' ' + cur;
    }
  }

  function phrase(mode, formatted, lang) {
    if (mode === 'from') {
      if (lang === 'en') return 'from ' + formatted;
      if (lang === 'uk') return 'від ' + formatted;
      return 'od ' + formatted;
    }
    if (mode === 'upto') {
      if (lang === 'en') return 'up to ' + formatted;
      if (lang === 'uk') return 'до ' + formatted;
      return 'do ' + formatted;
    }
    return formatted;
  }

  function formatDate(iso, lang) {
    if (!iso) return '';
    var parts = String(iso).split('-');
    if (parts.length !== 3) return iso;
    if (lang === 'en') return parts[2] + '.' + parts[1] + '.' + parts[0];
    return parts[2] + '.' + parts[1] + '.' + parts[0];
  }

  function formatMid(mid) {
    var n = Number(mid);
    if (!isFinite(n)) return String(mid);
    return String(Math.round(n * 10000) / 10000).replace('.', ',');
  }

  function noteText(lang, cur, date, mid) {
    var d = formatDate(date, lang);
    var m = formatMid(mid);
    if (lang === 'en') {
      return 'Indicative amounts in ' + cur + ', converted at the Narodowy Bank Polski mid rate of ' + d + ' (1 ' + cur + ' = ' + m + ' PLN). The amount at checkout may differ.';
    }
    if (lang === 'uk') {
      return 'Суми орієнтовні, у ' + cur + ', за середнім курсом Narodowy Bank Polski на ' + d + ' (1 ' + cur + ' = ' + m + ' PLN). На касі сума може відрізнятися.';
    }
    return 'Kwoty orientacyjne w ' + cur + ', przeliczone po średnim kursie Narodowego Banku Polskiego z dnia ' + d + ' (1 ' + cur + ' = ' + m + ' PLN). Na kasie kwota może się różnić.';
  }

  function fetchMid(code) {
    if (cache[code] && cache[code].promise) return cache[code].promise;
    cache[code] = {};
    cache[code].promise = fetch(NBP + encodeURIComponent(code) + '/?format=json')
      .then(function (r) {
        if (!r.ok) throw new Error('nbp ' + r.status);
        return r.json();
      })
      .then(function (j) {
        var rate = j && j.rates && j.rates[0];
        var mid = rate && Number(rate.mid);
        if (!isFinite(mid) || mid <= 0) throw new Error('nbp mid');
        cache[code].mid = mid;
        cache[code].date = rate.effectiveDate || '';
        cache[code].source = 'nbp';
        return cache[code];
      });
    return cache[code].promise;
  }

  function shopifyFallback(code) {
    var active = w.Shopify && Shopify.currency && Shopify.currency.active;
    var rate = w.Shopify && Shopify.currency && Number(Shopify.currency.rate);
    if (String(active || '').toUpperCase() !== code || !isFinite(rate) || rate <= 0) {
      return null;
    }
    return { mid: 1 / rate, date: '', source: 'shopify' };
  }

  function convert(pln, cur, rateObj) {
    if (cur === 'PLN') return pln;
    return pln / rateObj.mid;
  }

  function applyTo(root, rateObj, cur) {
    var lang = langOf(root);
    var nodes = root.querySelectorAll('[data-kayer-pln]');
    for (var i = 0; i < nodes.length; i += 1) {
      var el = nodes[i];
      var pln = parseFloat(el.getAttribute('data-kayer-pln'));
      if (!isFinite(pln)) continue;
      var mode = el.getAttribute('data-kayer-fx') || 'plain';
      el.textContent = phrase(mode, formatMoney(convert(pln, cur, rateObj), cur, lang), lang);
    }
    var notes = root.querySelectorAll('[data-kayer-nbp-note]');
    for (var n = 0; n < notes.length; n += 1) {
      if (cur === 'PLN') {
        notes[n].hidden = true;
        notes[n].textContent = '';
      } else {
        notes[n].hidden = false;
        notes[n].textContent = noteText(lang, cur, rateObj.date, rateObj.mid);
      }
    }
  }

  function paint(root) {
    if (!root) return Promise.resolve();
    var cur = targetCurrency(countryIso(root));
    if (cur === 'PLN') {
      applyTo(root, { mid: 1, date: '', source: 'pln' }, 'PLN');
      return Promise.resolve();
    }
    return fetchMid(cur)
      .catch(function () {
        var fb = shopifyFallback(cur);
        if (fb) return fb;
        throw new Error('fx');
      })
      .then(function (rateObj) {
        applyTo(root, rateObj, cur);
      })
      .catch(function () {});
  }

  function paintAll() {
    var roots = document.querySelectorAll('[data-kayer-nbp-root]');
    var jobs = [];
    for (var i = 0; i < roots.length; i += 1) jobs.push(paint(roots[i]));
    return Promise.all(jobs);
  }

  w.KayerNbpMarketFx = { paint: paint, paintAll: paintAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintAll);
  } else {
    paintAll();
  }
})(window);
